import React from 'react';
import { Props } from './analysisTable.type';

const TableRow = ({ label, value }: { label: string; value: number }) => {
  return (
    <tr>
      <td className="px-4 py-2">{label}</td>
      <td className="text-end px-4 py-2">{value}</td>
    </tr>
  );
};

function AnalysisTable({ data }: Props) {
  return (
    <table width="100%">
      <tr className="bg-gray-100 rounded fw-bold">
        <td className="px-4 py-2">Job Title</td>
        <td className="text-end px-4 py-2">Applicants</td>
      </tr>
      {data.map(({ label, value }, idx) => (
        <TableRow key={idx} label={label} value={value} />
      ))}
    </table>
  );
}

export default AnalysisTable;
